import React from 'react';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { useAppSelector } from '@/redux/hooks';
import DataTableLayout from './DataTableLayout';
import DataTableTitleBar from './DataTableTitleBar';
import DataTableFilters from '../Filters/DataTableFilters';
import { DirectLink } from '@/__configs/config_types';

export type DataTablePageProps = {
  pageConfig: DirectLink;
};

const DataTablePage = ({ pageConfig }: DataTablePageProps) => {
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  return (
    <DataTableLayout tableKey={pageConfig.id || ''}>
      <DataTableTitleBar />
      {currentTableKey === pageConfig.id && <DataTableFilters />}
    </DataTableLayout>
  );
};

export default DataTablePage;
